const utils = require('frontend-controller/lib/utils')
const CONSTANTS = require('frontend-controller/lib/constants');
module.exports = {
    config: {
        renderingSubTreeConditionally: true, // skips some error messages (e.g., used for inclusion actions which cannot find the parent during the render process)
    },

    model: {
        ninjaConfig: {},            // actual ninjaConfig provided by some actionParent.

        ninjaModule: '',            // actual ninjaModule (e.g., news)
        ninjaModuleConfig: {},      // actual ninjaModuleConfig defined by web-projects clientAppConfig (e.g., appConfig.ninjaModules.news)
        ninjaModuleSubConfig: {},   // actual ninjaModuleSubConfig defined by web-projects clientAppConfig (e.g., appConfig.ninjaModules.news.entityPart.coreInformation)

        entityPartID: null,         // actual entityPartID (e.g., cms_newsParts.newsPartID)
        langCode: '',               // actual langCode

        autoCreate: false,          // autoCreate granted?
        recordFound: false,         // has a record be found?
    },

    events: {
        addNinja: {
            type: 'click',
            selector: 'button',
            action: function(event){
                const self = event.data.component
                const $target = $(event.target)
                if($target.length > 0){
                    const fieldType = $target.data('fieldType')
                    if(fieldType === 'addNinjaComponentInstance'){
                        self.addNinjaComponentInstance()
                    }
                }
            }
        }
    },

    methods: {
        isBuildGranted(storage){
            if(storage.isServer){
                return CONSTANTS.COMPONENT.BUILD_GRANTED.TYPE.YES
            }

            this.model.ninjaConfig = this.getResourceRegisterContent('ninjaConfig') || {}

            const langCode = this.model.langCode = this.getResourceRegisterContent('entityPartLangCode')
            const entityPartParent = this.getResourceRegisterContent('entityPartParent')

            this.closest('templates_ninja_controller', controller => {
                const {
                    ninjaModule,
                    ninjaModuleConfig
                } = controller.getNinjaModuleParams()
                this.model.ninjaModule = ninjaModule
                this.model.ninjaModuleConfig = ninjaModuleConfig
            }, true)
            this.closest('templates_ninja_entityController', controller => {
                const {
                    entityID,
                    entityPartID,
                } = controller.getPartState(langCode)
                this.model.entityID = entityID
                this.model.entityPartID = entityPartID
            }, true)

            const entityCodeName = this.model.ninjaConfig.entityCodeName || 'missingEntityCodeName'
            const ninjaModuleConfig = this.model.ninjaModuleConfig || {}
            let ninjaModuleSubConfigKey = ''
            let parentRecordFound = false
            if(entityPartParent){
                ninjaModuleSubConfigKey = 'entityPart'
                parentRecordFound = !!this.model.entityPartID
            } else if(this.model.entityID) {
                ninjaModuleSubConfigKey = 'entity'
                parentRecordFound = true
            }

            const ninjaModuleSubConfig = this.model.ninjaModuleSubConfig = (ninjaModuleConfig[ninjaModuleSubConfigKey] || {})[entityCodeName]
            if(ninjaModuleSubConfig){
                const turnedOn = ninjaModuleConfig.turnedOn && ninjaModuleSubConfig.turnedOn

                if(turnedOn && parentRecordFound){
                    this.model.autoCreate = ninjaModuleSubConfig.autoCreate

                    return CONSTANTS.COMPONENT.BUILD_GRANTED.TYPE.YES
                }
            } else {
                console.error(`ninjaModuleSubConfig missing: frontend-controller/client/appConfig.js ninjaModules.${this.model.ninjaModule}.${ninjaModuleSubConfigKey}.${entityCodeName}`)
            }

            this.closest('base_tabStrip_tabContent', tabContent => {
                tabContent.close()
            })

            return CONSTANTS.COMPONENT.BUILD_GRANTED.TYPE.NO
        },

        getResourceFilters(storage, resourceFilters, actionKey){
            if(actionKey === 'refreshResources'){
                const ninjaConfig = this.model.ninjaConfig || {}
                const ninjaModuleSubConfig = this.model.ninjaModuleSubConfig || {}

                resourceFilters = {
                    ...resourceFilters,
                    ...ninjaConfig,
                    autoCreate: ninjaModuleSubConfig.autoCreate,
                    createDirtyFields: {
                        ...(ninjaConfig.createDirtyFields || {}),
                        ...(ninjaModuleSubConfig.createDirtyFields || {}),
                    },
                }
            }

            return resourceFilters
        },

        sanitizeResources(){
            this.model.recordFound = !utils.isEmpty(this.resourceData)
        },

        /**
         * creates a cms_componentsInstances entry according to the given ninja attributes.
         */
        addNinjaComponentInstance(){
            const ninjaConfig = this.model.ninjaConfig || {}
            const createDirtyFields = (this.model.ninjaModuleSubConfig || {}).createDirtyFields || {}

            return this.performAction(
                this.prepareAction('ninja.componentInstance.insert', undefined, undefined, {
                    source: {
                        submit: {
                            data: {
                                data: {
                                    attributes: {
                                        parentEntityType: ninjaConfig.parentEntityType,
                                        parentEntityID: ninjaConfig.parentEntityID,
                                        entityCodeName: ninjaConfig.entityCodeName,
                                        ninjaMeta: ninjaConfig,
                                        ...(ninjaConfig.createDirtyFields || {}),
                                        ...createDirtyFields,
                                    },
                                }
                            }
                        }
                    }
                })
            ).then(() => this.refresh())
            .fail(error => utils.promise.reject(error))
        },
    },

    handlers: [
        {
            name: 'afterCancel',
            componentClass: 'templates_propertiesForms_componentContentForm',
            handle: function(callerComponent){
                // check if the caller is the child of this ninja-gatekeeper-componentInstance
                callerComponent.closest('templates_ninja_gatekeeper_componentInstance', gatekeeper => {
                    if(gatekeeper.componentIndex === this.componentIndex){
                        this.closest('base_tabStrip_tabContent', tabContent => {
                            tabContent.refresh()
                        })
                    }
                })
            }
        },
        {
            name: 'onSubmitDone',
            componentClass: 'templates_propertiesForms_componentContentForm',
            handle: function(callerComponent, nodeData, insertPerformed, options){
                // check if the caller is the child of this ninja-gatekeeper-componentInstance
                callerComponent.closest('templates_ninja_gatekeeper_componentInstance', gatekeeper => {
                    if(gatekeeper.componentIndex === this.componentIndex){
                        this.refresh()
                    }
                }, true)
            }
        }
    ]
}
